import styled from "styled-components";

export const Container = styled.div`
  margin-bottom: 40px;
`;

export const Header = styled.p`
  font-size: 20px;
  line-height: 28px;
  font-weight: 900;
  margin-bottom: 20px;
`;

export const List = styled.ul`
  list-style: none;
  padding: 0;
`;

export const ListLi = styled.li`
  display: flex;
  align-items: center;
  padding: 20px;
  &:nth-child(even) {
    background-color: #f1f1f1;
  }
`;

export const Title = styled.span`
  font-size: 16px;
  line-height: 1;
  color: #000000;
  padding-left: 10px;
  margin-bottom: 4px;
  font-weight: 900;
`;

export const Description = styled.span`
  font-size: 13px;
  line-height: 1;
  color: #000000;
  padding-left: 10px;
`;

export const Link = styled.a`
  display: flex;
  flex-direction: column;
  width: calc(100% - 27px);
`;
